import Serializer from 'umg-ember-backend/serializers/application';

export default class LinkPatternSerializer extends Serializer {
  attrs = {
    position: 'cmsPosition',
    tradePartner: 'partnerTradeId',
    shopType: 'categoryId4',
    variantChannel: 'vChannelId',
  };
}
